import { ContasReceber } from '../../model/financeiro/contasReceber';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericService } from '../generics/generic.service';
import { Financeiro } from 'src/app/model/financeiro/financeiro';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})

@AutoRegisterService()
export class FinanceiroService extends GenericService<Financeiro>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("financeiro")
  }
}
